module.exports = __webpack_public_path__ + "media/components/dropdown-arrow-green-3deffe67.svg";